<mat-select [(ngModel)]="value" #select (closed)="selectClose($event)" panelWidth="215px"
            disableRipple="true"
            [panelClass]="{sizes: true, hasExtras: extraOptions && extraOptions.length > 0 || range.max < 1}">
  <mat-select-trigger>
    {{ value | size | inches }}
  </mat-select-trigger>
  @for (extraOption of extraOptions; track extraOption.value + extraOption.text) {
  <mat-option [value]="extraOption.value">
    <ng-container *ngIf="extraOption.text">
      {{ extraOption.text}}
    </ng-container>
    <ng-container *ngIf="!extraOption.text">
      {{ extraOption.value | size: (range.max >= 1 ? '' : 'multichar') | inches }}
    </ng-container>
    <ng-container *ngIf="extraOption.extraText">
      <span class="mat-option-extra-text">{{ extraOption.extraText }}</span>
    </ng-container>
  </mat-option>
  }
  <mat-divider *ngIf="extraOptions && extraOptions.length > 0"></mat-divider>
  @for (size of sizes; track size.value) {
    <mat-option [value]="size.value" [disabled]="size.value < range.min"
                [style.opacity]="size.value === 0 ? 0 : 1"
                [ngClass]="{'tall': firstAvailableFractionForSize(size.value) && this.fractions.length > 8,
                            'not-active-size': size !== activeSize}">
      {{ size.value | size: (range.max >= 1 ? '' : 'multichar') | inches }}
    </mat-option>
    <ng-container *ngIf="size.value >= 1 && firstAvailableFractionForSize(size.value)">
      <mat-optgroup *ngIf="size === activeSize || size === selectedSize"
                    [style.opacity]="size !== activeSize ? 0 : 1"
                    [ngClass]="{'tall': firstAvailableFractionForSize(size.value) && this.fractions.length > 8}">
        @for (frac of fractions; track frac) {
          <mat-option class="frac" [value]="size.value + frac"
                      [disabled]="(size.value !== 0 && size.value < 1) || size.value + frac < range.min || size.value + frac > range.max">
            {{ frac | size }}
          </mat-option>
        }
      </mat-optgroup>
      <div class="mat-mdc-option fractions-activator" (click)="activate(size)"
                  [ngClass]="{'tall': firstAvailableFractionForSize(size.value) && this.fractions.length > 8}"
                  *ngIf="size !== activeSize">
        <span>…</span>
      </div>
    </ng-container>
  }
</mat-select>
